import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-div-percent',
    template: `
        <ng-container *ngIf="mode === 'advance'">
            <div class="data-rise" *ngIf="Payout > 0 && Payout <= 40">
                {{ formattedPercent() }}
            </div>
            <div class="text-primary" *ngIf="Payout > 40 && Payout <= 70">
                <span>{{ formattedPercent() }}</span>
            </div>
            <div class="data-fall" *ngIf="Payout > 70">
                <span>{{ formattedPercent() }}</span>
            </div>
            <div class="" *ngIf="Payout == 0">
                {{ formattedPercent() }}
            </div>
        </ng-container>
    `,
})
export class ElDivPercentComponent {
    @Input() mode: 'normal' | 'advance' = 'advance';
    @Input() percent: number;
    @Input() Payout: number

    public formattedPercent() {
        return `${Number(this.percent).toFixed(2)}%`;
    }
}
